import { RadioGroup, RadioGroupProps } from "@blueprintjs/core";
import { getIn } from "formik";
import { FGFormGroup, IFGFormGroupProps, useFGContext } from "nsitools-react";
import React from "react";

type RadioItems = { options: RadioGroupProps["options"] };

const FGRadioGroup: React.FC<
  Omit<RadioGroupProps, "onChange" | "selectedValue"> &
    RadioItems & {
      name: string;
      loading?: boolean;
    }
> = ({ name, options, loading = false, ...props }) => {
  const { formik } = useFGContext();

  const onChange = React.useCallback(
    (e) => {
      formik.setFieldValue(name, +e.currentTarget.value);
    },
    [formik, name]
  );
  const selectedValue = React.useMemo(
    () => +getIn(formik.values, name),
    [formik.values, name]
  );

  return (
    <RadioGroup
      onChange={onChange}
      selectedValue={selectedValue}
      options={options}
      {...props}
    />
  );
};

export type FgRadioInputProps = RadioItems &
  Omit<IFGFormGroupProps, "children"> & { disabled?: boolean };
export const FGRadioInput: React.FC<FgRadioInputProps> = ({
  options,
  disabled,
  ...props
}) => {
  const { disabled: globalDisabled, editMode } = useFGContext();

  const finalOptions = React.useMemo(() => {
    return options?.map((o) => {
      o.disabled = disabled || globalDisabled || !editMode;
      return o;
    });
  }, [disabled, editMode, globalDisabled, options]);
  return (
    <FGFormGroup {...props}>
      {({ name }) => (
        <FGRadioGroup
          disabled={disabled || globalDisabled}
          name={name}
          options={finalOptions}
        />
      )}
    </FGFormGroup>
  );
};
